"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinleyAiPromptResponseTerminalStatuses = exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesPageNumberSupportedFileExt = exports.FinleyAiExtractValuesFileExtToEngineSupport = exports.FinleyAiExtractValuesEngineFileExtSupport = exports.FinleyAiExtractValuesDefaultEngine = void 0;
exports.FinleyAiExtractValuesDefaultEngine = {
    html: 'beautifulSoup',
    pdf: 'pdfMiner',
    jpeg: 'textract',
    jpg: 'textract',
    json: 'rawText',
    png: 'textract',
    tif: 'textract',
    tiff: 'textract',
    txt: 'rawText',
};
exports.FinleyAiExtractValuesEngineFileExtSupport = {
    beautifulSoup: ['html'],
    textract: ['pdf', 'png', 'jpeg', 'jpg', 'tif', 'tiff'],
    pdfMiner: ['pdf'],
    rawText: ['txt', 'json'],
};
// reverse map of FinleyAiExtractValuesEngineFileExtSupport
exports.FinleyAiExtractValuesFileExtToEngineSupport = Object.entries(exports.FinleyAiExtractValuesEngineFileExtSupport).reduce((acc, [eng, exts]) => {
    exts.forEach((ext) => {
        acc[ext].push(eng); // guaranteed by type system, Object.entries loses typing
    });
    return acc;
}, {
    html: [],
    pdf: [],
    png: [],
    jpeg: [],
    jpg: [],
    json: [],
    tiff: [],
    tif: [],
    txt: [],
});
exports.FinleyAiExtractValuesPageNumberSupportedFileExt = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
];
exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesEngineFileExtSupport.textract;
exports.FinleyAiPromptResponseTerminalStatuses = [
    'failure',
    'success',
];
//# sourceMappingURL=FinleyAi.js.map